import { CourseData, UnitId, SubunitId, SubunitData, ActivityData } from 'course-types';
import { QuizQuestionData } from 'quiz-types';

const QuizBuilderService = {
  areOptionsBlank(questions: Array<QuizQuestionData>, activeQuestionIndex: number): boolean {
    const currQuesetion = questions[activeQuestionIndex];
    if (currQuesetion.type !== 'Multiple Choice' || !currQuesetion.options) {
      return true;
    }
    for (const option of currQuesetion.options) {
      if (option.value === '') {
        return true;
      }
    }
    return false;
  },

  isQuestionBlank(questions: Array<QuizQuestionData>, activeQuestionIndex: number): boolean {
    const currQuesetion = questions[activeQuestionIndex];
    if (!currQuesetion) {
      return true;
    }
    if (
      currQuesetion.question === '' ||
      (currQuesetion.type === 'Multiple Choice' &&
        this.areOptionsBlank(questions, activeQuestionIndex))
    ) {
      return true;
    }
    return false;
  },

  isQuizReadyToSubmit(questions: Array<QuizQuestionData>) {
    for (let q = 0; q < questions.length; ++q) {
      if (this.isQuestionBlank(questions, q)) {
        return false;
      }
    }
    return true;
  },

  getAllQuizzes(courseData: CourseData): Array<{
    unitId: UnitId;
    subunitId: SubunitId | null;
    subunitData: SubunitData | null;
    data: ActivityData;
  }> {
    const quizData = [];
    for (const u in courseData.units) {
      const unitData = courseData.units[u as UnitId];
      if (unitData.activities) {
        for (const a of unitData.activities) {
          if (typeof a !== 'number' && a.type === 'quiz') {
            quizData.push({ unitId: u as UnitId, subunitId: null, subunitData: null, data: a });
          }
        }
      }
      for (const s in unitData.subunits) {
        const subData = unitData.subunits[s as SubunitId];
        for (const a of subData.activities) {
          if (typeof a !== 'number') {
            if (a.type === 'quiz') {
              quizData.push({
                unitId: u as UnitId,
                subunitId: s as SubunitId,
                subunitData: subData,
                data: a,
              });
            }
          }
        }
      }
    }
    return quizData;
  },
};

export default QuizBuilderService;
